export const testable = {
  UseXMLHTTPRequest: true
}
